import { Date } from './date';
import { ICD } from './icd';
import { Site } from './site';

export type MedicationOccurrence = {
  id: number;
  createdAt: Date;
  date: Date;
  dosage?: string;
};

export type Medication = {
  id: number;
  reminderId: number;
  title: string;
  icd: ICD;
  uuid: string;
  site: Site;
  isAnswered: boolean;
  maximumDosage?: number;
  phase: string;
  sober: boolean;
  notes?: string;
  patientId: number;
  administrationType: MedicationAdministrationTypes;
  occurrence: MedicationOccurrence;
  form?: string;
  medicationPlanId?: string;
  isMedicationPlan: boolean;
  lifespan: number;
};

export type ReminderMedication = Omit<Medication, 'occurrence'> & {
  occurrences: MedicationOccurrence[];
};

export enum MedicationPhaseTypes {
  Planning = 1,
  Treatment = 2,
  FollowUp = 3,
  Diagnosis = 4,
  Screening = 5,
}

export enum MedicationAdministrationTypes {
  Narcotic = 1,
  Oral = 2,
  Intravenous = 3,
  Subcutaneous = 4,
}

export enum MedicationDosageTimes {
  Morning = 'morning',
  Midday = 'midday',
  Evening = 'evening',
  Night = 'night',
  Other = 'other',
}

export type MedicationWithDosageKeys = {
  [key in MedicationDosageTimes]?: Medication[];
};

export type MedicationPlan = {
  id: string;
  version: number;
  name: string;
  xmlData: string;
  birthDate: Date;
  page?: number;
  totalPages?: number;
};

export type DecryptedMedicationPlanDocument = {
  uuid: string;
  hash: string;
  pages: number;
  printOutDate: string;
  isActivate: boolean;
  scanningDate: string;
  createdAt: string;
  updatedAt: string;
  assetId: number;
  patientId: number;
  asset: MedicationPlanAsset;
};

type MedicationPlanAsset = {
  id: number;
  name: string;
  thumbnailURL: string;
  previewURL: string;
  directLink: string;
};
